import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { ConfirmationService } from '../services/confirmation.service';

@Directive({
  selector: '[umssExternalLinkWarning]',
  standalone: true
})
export class UmssExternalLinkWarningDirective {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly confirmationService = inject(ConfirmationService);

  @HostListener('click', ['$event'])
  async onClick(event: MouseEvent): Promise<void> {
    const target = event.target;
    const anchor = target instanceof Element ? target.closest('a[href]') : null;
    if (!(anchor instanceof HTMLAnchorElement)) return;
    if (!this.elementRef.nativeElement.contains(anchor)) return;

    event.preventDefault();
    event.stopPropagation();

    const url = this.getSafeUrl(anchor.href);
    if (!url) return;

    const confirmed = await this.confirmationService.confirm({
      title: 'Open external link?',
      message: `This link opens an external website:\n\n${url}`,
      confirmLabel: 'Continue',
      cancelLabel: 'Cancel',
      type: 'Warning'
    });

    if (confirmed) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  private getSafeUrl(value: string): string | null {
    try {
      const url = new URL(value);
      return ['http:', 'https:', 'mailto:'].includes(url.protocol)
        ? url.href
        : null;
    } catch {
      return null;
    }
  }
}
